<div *ngIf="report" style="position: relative; padding: 20px;" class="logorow">
  <div style="position: relative; height: 80px;width: 100%;">
    <img style="margin: 10px 10px 10px 40px; height: 60px!important;" [src]="clientLogo" *ngIf="clientLogo"/>

    <img style="right: 0; top: 10px; height: 60px!important; position:absolute!important;" [src]="consultantLogo"
         *ngIf="consultantLogo"/>
  </div>
  <div><h2 style="color:var(--main-ui-color, orange);display: inline-block;">{{project.name}} Scoring Report</h2>
    <div style="float: right;margin: 20px;" (click)="print()"><i style="font-size: 1.5em;" class="pi pi-print"></i></div>
  </div>


  <div style="display: flex; flex-direction: row;">
    <div style="flex:0 0 50%">
      <div class="name">Date/Time Generated</div>
      <div class="value">{{report.date | date: 'shortDate'}} {{report.date | date: 'shortTime'}}</div>
    </div>
    <div style="flex:0 0 50%">
      <div class="name">Project Name</div>
      <div class="value">{{project.name}}</div>
    </div>
  </div>
  <div style="display: flex; flex-direction: row;">
    <div style="flex:0 0 20%">
      <div class="name">Deductions</div>
      <div class="value">{{report.score}}</div>
    </div>
    <div style="flex:0 0 20%">
      <div class="name">Total Score</div>
      <div class="value">{{report.total}}</div>
    </div>
  </div>
  <div style="display: flex; flex-direction: row;" *ngIf="report.lastPoamCompletionDate">
    <div style="flex:0 0 50%">
      <div class="name">Last POAM Completion Date</div>
      <div class="value">{{report.lastPoamCompletionDate | date: 'shortDate'}}</div>
    </div>
  </div>
  <h1 *ngIf="report.lastPoam">POAM Details</h1>
  <div style="display: flex; flex-direction: row;" *ngIf="report.lastPoam">
    <div style="flex:0 0 50%">
      <div class="name">Control Description</div>
      <div
        class="value">{{report.lastPoamControl.controlItem.complianceAreaControlId}} {{report.lastPoamControl.controlItem.description}}</div>
    </div>
    <div style="flex:0 0 50%">
      <div class="name">Status</div>
      <div class="value">{{actionItemStatuses[report.lastPoam.currentStatus]}}</div>
    </div>
  </div>
  <div style="display: flex; flex-direction: row;" *ngIf="report.lastPoam">
    <div style="flex:0 0 50%">
      <div class="name">Description of Weakness</div>
      <div class="value">{{report.lastPoam.weaknessDescription}}</div>
    </div>
    <div style="flex:0 0 50%">
      <div class="name">Next Steps</div>
      <div class="value">{{report.lastPoam.remediationPlansActionsMilestones}}</div>
    </div>
  </div>
  <div style="display: flex; flex-direction: row;" *ngIf="report.lastPoam">
    <div style="flex:0 0 50%">
      <div class="name">Responsible Party</div>
      <div class="value">{{report.lastPoam.responsibleParty}}</div>
    </div>
    <div style="flex:0 0 50%">
      <div class="name">Scheduled Completion Date</div>
      <div class="value">{{report.lastPoam.scheduledCompletionDate | date: 'shortDate'}}</div>
    </div>
  </div>
  <div style="font-size: 0.8em">
    <p-table [value]="report.filteredControlItems">
      <ng-template pTemplate="header">
        <tr style="white-space: nowrap;font-weight: bold">
          <th style="width: 5%;">ID</th>
          <th>Description</th>
          <th style="width: 5em">Deduction</th>
          <th style="width: 5em">Value</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{item.controlItem.complianceAreaControlId}}</td>
          <td>{{item.controlItem.description}}</td>
          <td>{{item.score}}</td>
          <td>{{item.controlItem.value}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="text-center; margin-top: 20px;">
    <button mat-raised-button (click)="close()">Close</button>
  </div>
</div>
